import { useQuery } from '@tanstack/react-query'
import { api } from '@/routes/shared/_api'
import { BankAccountsTypes, bankAccountsSchema } from './schema'
import { datadogLogs } from '@datadog/browser-logs'
import { z } from 'zod'

const ORDER = ['individual', 'joint', 'foe_trust', 'foe_entity', 'sdira']

export const getAccounts = async () => {
  const response = await api.get('/dashboard/bank-accounts')
  const parsedData = bankAccountsSchema?.safeParse(response)

  const filterAndSort = (
    data: z.infer<typeof bankAccountsSchema> | undefined
  ) => {
    return data
      ?.filter((account) => account?.investment_account_type !== 'foe_sdira')
      ?.sort((a, b) => {
        if (!a?.investment_account_type || !b?.investment_account_type) return 0
        return (
          ORDER.indexOf(a.investment_account_type) -
          ORDER.indexOf(b.investment_account_type)
        )
      })
  }

  if (!parsedData.success) {
    datadogLogs.logger.error(
      'Zod schema Error - get-bank-accounts',
      parsedData.error
    )
    const unsafeUnparsedData = response as unknown as z.infer<
      typeof bankAccountsSchema
    >
    return filterAndSort(unsafeUnparsedData)
  } else {
    return filterAndSort(parsedData.data)
  }
}

export const useBankAccounts = () => {
  return useQuery<BankAccountsTypes>({
    queryKey: ['bank-accounts'],
    queryFn: getAccounts,
    staleTime: Infinity,
    keepPreviousData: true,
  })
}
